export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export function fortmatCurrency(
  value: number | undefined | null,
  currency: string = 'USD',
  locales: string = 'en-US',
  minimumFractionDigits: number = 2,
  maximumFractionDigits: number = 3,
) {
  const valueOrNull = value ?? null;

  return !!valueOrNull
    ? new Intl.NumberFormat(locales, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: minimumFractionDigits,
        maximumFractionDigits: maximumFractionDigits,
      }).format(valueOrNull)
    : '';
}
